/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'forbidden': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17 10a7 7 0 01-11.584 5.29l9.875-9.874A6.973 6.973 0 0117 10zM4.71 14.584l9.874-9.875a7 7 0 00-9.874 9.874zM10 18a8 8 0 100-16 8 8 0 000 16z" _fill="#1F222C"/>'
  }
})
